import React from 'react';


import {
    Cards,
    CardsPropertyFiltering,
    Button,
    CardsPagination, Spinner,
    Tabs
} from 'AWS-UI-Components-React';

import {
    JSClient,
    Header
} from '../common';

const cardDefinition = {
    // header: item => item.name,
    sections: [
        {
            id: "searchid",
            width: 50,
            header: item => "Search Id",
            content: item => item.searchId
        },
        {
            id: "uuid",
            width: 50,
            header: item => "Report Id",
            content: item => item.uuid
        },
        {
            id: "user",
            width: 50,
            header: "User",
            content: item => item.user
        },
        {
            id: "startTime",
            width: 50,
            header: "Start Time",
            content: item => (new Date(parseInt(item.startTime))).toLocaleString()
        },
        {
            id: "endTime",
            width: 50,
            header: "End Time",
            content: item => (new Date(parseInt(item.endTime))).toLocaleString()
        },
        {
            id: "downloadLink",
            width: 50,
            header: "Download Link",
            content: item => <a href="https://foc-analysts-generated-reports-dub.s3-eu-west-1.amazonaws.com/download.csv">Link</a>
        }
    ]
};

const cardsPerRow = [
    {
        "cards": 1
    },
    {
        "minWidth": 500,
        "cards": 2
    }
];

export class ReportCard extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            unknownloaderror: false,
            initialLoadDone: false,
            user: "",
            searchLoadDone: false,
            reports: [],
            searchId:props.searchId
        };
        this.clientLoaded = this.clientLoaded.bind(this);
        this.getReportsResultHandler = this.getReportsResultHandler.bind(this);
    }

    clientLoaded() {
        this.client.getIdentity(identityResult => {
            this.setState({...this.state, user: identityResult.username, initialLoadDone: true});
            this.client.getReports({
                searchId: this.state.searchId,
            }, this.getReportsResultHandler);
        });
    }

    componentWillMount() {
        this.client = new JSClient({onReady: this.clientLoaded});
    }

    // componentWillReceiveProps(nextProps, nextContext) {
    //     if (!objectCompare(this.state.props, nextProps)) {
    //         this.setState({...this.state, props: JSON.parse(JSON.stringify(nextProps)), taskLoadDone: false});
    //     }
    // }
    //
    // componentWillUpdate(nextProps, nextState, nextContext) {
    //     if (!nextState.taskLoadDone)
    //         this.client.getTasks({
    //             type: nextState.type,
    //             user: nextState.user, ...nextProps
    //         }, this.getTasksResultHandler);
    // }

    getReportsResultHandler(searchResult) {
        this.setState({reports: searchResult.reports, searchLoadDone: true});
    }

    headerCounter(items) {
        return items.length;
    }

    render() {
        if (!this.state.initialLoadDone) {
            return (<div className='offset-xxs-1 col-s-8 offset-l-2 col-xl-3'><Spinner/></div>)
        }
        return (
            <div>

                <div>

                    <Cards
                        cardDefinition={cardDefinition}
                        items={this.state.reports}
                        cardsPerRow={cardsPerRow}
                        loadingText="Loading resources"
                        wrapLines={false}
                        header={<h2>
                            Filter Searches
                        </h2>}
                        empty={<div className="awsui-util-t-c">
                            <div className="awsui-util-pt-xs awsui-util-mb-xs">
                                <b>
                                    No resources
                                </b>
                            </div>
                            <p className="awsui-util-mb-s">
                                No resources to display
                            </p>
                            <div className="awsui-util-mb-m">
                                <Button text="Create resource"></Button>
                            </div>
                        </div>}
                        noMatch={<div className="awsui-util-t-c">
                            <div className="awsui-util-pt-xs awsui-util-mb-xs">
                                <b>
                                    No matches
                                </b>
                            </div>
                            <p className="awsui-util-mb-s">
                                We can’t find a match.
                            </p>
                            <div className="awsui-util-mb-m">
                                <Button text="Clear filter"></Button>
                            </div>
                        </div>}
                    >
                        <CardsPagination pageSize={10}></CardsPagination>
                        <CardsPropertyFiltering
                            filteringOptions={[
                                {
                                    groupValuesLabel: 'Period Values',
                                    propertyKey: 'period',
                                    propertyLabel: 'Period',
                                    values: ['1', '2']
                                },
                                {
                                    groupValuesLabel: 'Name Values',
                                    propertyKey: 'name',
                                    propertyLabel: 'Name',
                                    values: []
                                }
                            ]}
                            groupValuesText="Values"
                            groupPropertiesText="Properties"
                            operationAndText="and"
                            operationNotAndText="and not"
                            operationOrText="or"
                            operationNotOrText="or not"
                            clearFiltersText="Clear filter"
                            allowFreeTextFiltering={true}
                            filteringCountTextFunction={count => `${count} ${count === 1 ? 'match' : 'matches'}`}
                        />
                    </Cards>
                </div>
            </div>


        );
    }
}




// WEBPACK FOOTER //
// ./src/components/cards/report_card.jsx